/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventStarterPackInfoAddBudgetRequest model module.
 * @module model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest
 * @version 1.0
 */
class EventsControllerDtoEventStarterPackInfoAddBudgetRequest {
    /**
     * Constructs a new <code>EventsControllerDtoEventStarterPackInfoAddBudgetRequest</code>.
     * @alias module:model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest
     * @param packNo {Number} 
     * @param addXper {Number} 
     * @param transactionHash {String} 
     */
    constructor(packNo, addXper, transactionHash) { 
        
        EventsControllerDtoEventStarterPackInfoAddBudgetRequest.initialize(this, packNo, addXper, transactionHash);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, packNo, addXper, transactionHash) { 
        obj['packNo'] = packNo;
        obj['addXper'] = addXper;
        obj['transactionHash'] = transactionHash;
    }

    /**
     * Constructs a <code>EventsControllerDtoEventStarterPackInfoAddBudgetRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventStarterPackInfoAddBudgetRequest} The populated <code>EventsControllerDtoEventStarterPackInfoAddBudgetRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventStarterPackInfoAddBudgetRequest();

            if (data.hasOwnProperty('packNo')) {
                obj['packNo'] = ApiClient.convertToType(data['packNo'], 'Number');
            }
            if (data.hasOwnProperty('addXper')) {
                obj['addXper'] = ApiClient.convertToType(data['addXper'], 'Number');
            }
            if (data.hasOwnProperty('transactionHash')) {
                obj['transactionHash'] = ApiClient.convertToType(data['transactionHash'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventStarterPackInfoAddBudgetRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventStarterPackInfoAddBudgetRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of EventsControllerDtoEventStarterPackInfoAddBudgetRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['transactionHash'] && !(typeof data['transactionHash'] === 'string' || data['transactionHash'] instanceof String)) {
            throw new Error("Expected the field `transactionHash` to be a primitive type in the JSON string but got " + data['transactionHash']);
        }

        return true;
    }


}

EventsControllerDtoEventStarterPackInfoAddBudgetRequest.RequiredProperties = ["packNo", "addXper", "transactionHash"];

/**
 * @member {Number} packNo
 */
EventsControllerDtoEventStarterPackInfoAddBudgetRequest.prototype['packNo'] = undefined;

/**
 * @member {Number} addXper
 */
EventsControllerDtoEventStarterPackInfoAddBudgetRequest.prototype['addXper'] = undefined;

/**
 * @member {String} transactionHash
 */
EventsControllerDtoEventStarterPackInfoAddBudgetRequest.prototype['transactionHash'] = undefined;






export default EventsControllerDtoEventStarterPackInfoAddBudgetRequest;

